import { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Routes, Route, Navigate } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Can } from "./casl/Can";
import { AppRoutes, NonAuthRoutes } from "./views/AppRoutes";
import { PATHS } from "./constants";
import { theme } from "./helpers/materialUITheme";
import { ErrorFallback } from "./views/errorsPages/ErrorFallBack";
import PageNotFound from "./views/errorsPages/PageNotFound";
import Layout from "./views/containers/Layout";
import { useAppSelector } from "./hooks/redux";
import { parseJsonToken } from "./helpers/helper";
import "./styles/globalStyles/globalstyles.css";
import "./styles/variablesStyles/colors/colors.css";
import "./styles/variablesStyles/fonts/fonts.css";
import "./styles/variablesStyles/sizes/sizes.css";
import "./styles/buttons/buttons.css";

function App() {
  const token = useAppSelector((state) => state.users.token);
  const [permissions, setPermissions] = useState([]);
  const isAuthenticated = !!token;

  useEffect(() => {
    token && parseJsonToken({ token, setPermissions });
  }, [token]);

  const protectedRoutes = AppRoutes.filter(
    (item) => permissions.includes(item.permission) || item.permission === "profile"
  );

  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        {isAuthenticated ? (
          <Can I="manage" a="auth">
            <Layout>
              <Routes>
                {protectedRoutes.map((routeConfig, index) => (
                  <Route
                    key={index}
                    exact={routeConfig.exact}
                    path={routeConfig.path}
                    element={routeConfig.component}
                  />
                ))}
                <Route path={PATHS.SLASH} element={<Navigate to={PATHS.OBJECTS_ON_MAP} replace />} />
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </Layout>
          </Can>
        ) : (
          <Can I="manage" a="notAuth">
            <Routes>
              {NonAuthRoutes.map((routeConfig, index) => (
                <Route key={index} exact={routeConfig.exact} path={routeConfig.path} element={routeConfig.component} />
              ))}
              <Route path={PATHS.SLASH} element={<Navigate to={PATHS.LOGIN_ROUTE} replace />} />
              <Route path="*" element={<Navigate to={PATHS.LOGIN_ROUTE} replace />} />
            </Routes>
          </Can>
        )}
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
